module.exports = __webpack_public_path__ + "media/images/faces/face10-eb4f65b6bf7e9f039c57a70e2963e0ec.jpg";